export * from './i18n'

export const EMPTY_CELL_VALUE = '-'
